import { Filters, Resident } from '../domain/Resident';
import { ResidentRepository } from '../domain/ResidentRepository';

export async function getResidents(
  residentRespository: ResidentRepository,
  filters: Filters
): Promise<Resident> {
  return residentRespository.get(filters);
}
